import styled from "styled-components";

export interface Props {
  className?: string;
  open: boolean;
  onClick: () => void;
}

const HamburgerIconToStyle: React.FC<Props> = ({
  className,
  open,
  onClick,
}) => {
  const openClass = open ? " open" : "";
  return (
    <div className={className + openClass} onClick={onClick}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export const HamburgerIcon = styled(HamburgerIconToStyle)`
  cursor: pointer;
  margin: auto;
  transform: rotate(0);
  transition: 0.5s ease-in-out;
  -webkit-transform: rotate(0);
  width: 40px;
  height: 40px;
  position: fixed;
  top: 25px;
  right: 25px;
  z-index: 101;
  div {
    background: #a6a6a6;
    border-radius: 9px;
    display: block;
    height: 6px;
    left: 0;
    position: absolute;
    transform: rotate(0);
    transition: 0.25s ease-in-out;
    -webkit-transform: rotate(0);
    width: 100%;
  }
  div:nth-child(1) {
    top: 0;
  }
  div:nth-child(2),
  div:nth-child(3) {
    top: 12px;
  }
  div:nth-child(4) {
    top: 24px;
  }
  &.open div:nth-child(1),
  &.open div:nth-child(4) {
    left: 50%;
    top: 18px;
    width: 0%;
  }
  &.open div:nth-child(2) {
    background: #a6a6a6;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  &.open div:nth-child(3) {
    background: #a6a6a6;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
`;
